var exports = {
  "D": "truncatedTokenWithIcon___87Jnz",
  "q": "truncatedTokenNoIcon__nRfBJm",
};

module.exports = exports;
